/**
 * TabBar Component
 * Bottom navigation bar for switching between main screens
 */

import { useTranslation } from '../hooks/useTranslation';
interface TabBarProps {
  activeTab: 'home' | 'trade' | 'battery' | 'staking' | 'ai-trader' | 'assets' | 'stats' | 'settings' | 'tasks';
  onTabChange: (tab: 'home' | 'trade' | 'battery' | 'staking' | 'ai-trader' | 'assets' | 'stats' | 'settings' | 'tasks') => void;
}

export function TabBar({ activeTab, onTabChange }: TabBarProps) {
  const { t } = useTranslation();

  const allTabs = [
    { id: 'home' as const, icon: '🏠', label: t('navigation.home') },
    { id: 'trade' as const, icon: '📈', label: t('navigation.trade') },
    { id: 'battery' as const, icon: '🔋', label: t('navigation.battery') },
    { id: 'staking' as const, icon: '🏦', label: t('navigation.staking') },
    { id: 'ai-trader' as const, icon: '🤖', label: 'AI Trader' },
    { id: 'assets' as const, icon: '💰', label: t('navigation.assets') },
    { id: 'tasks' as const, icon: '🎯', label: t('navigation.tasks') },
    { id: 'stats' as const, icon: '🏆', label: t('leaderboard.title') },
    { id: 'settings' as const, icon: '👤', label: t('navigation.profile') },
  ];

  const tabs = allTabs;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#2a2a2a',
        borderTop: '1px solid #3a3a3a',
        display: 'flex',
        justifyContent: 'space-around',
        padding: '6px 0',
        maxWidth: '480px',
        margin: '0 auto',
        zIndex: 1000,
      }}
    >
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '2px',
            padding: '4px 2px',
            backgroundColor: 'transparent',
            border: 'none',
            color: activeTab === tab.id ? '#4a90e2' : '#888',
            cursor: 'pointer',
            transition: 'all 0.2s',
            fontSize: '9px',
            minWidth: 0,
          }}
        >
          <span style={{ fontSize: '20px' }}>{tab.icon}</span>
          <span
            style={{
              fontWeight: activeTab === tab.id ? 'bold' : 'normal',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100%',
            }}
          >
            {tab.label}
          </span>
        </button>
      ))}
    </div>
  );
}
